import { ConnectionOptions, Connection as StardogConnection } from 'stardog';
import {
  BaseConnection,
  ConnectionConfig,
  getStardogConnection,
} from 'vet-bones/utils';

export interface MarketplaceOptions extends ConnectionOptions {
  database: string;
}

export interface ConnectionFactory {
  connection: StardogConnection;

  connectionIndex: number | undefined;

  options: MarketplaceOptions;
}

export const create = (
  idx: number | undefined,
  opts: MarketplaceOptions,
  config: ConnectionConfig
): ConnectionFactory =>
  new DefaultConnectionFactory(idx, opts, getStardogConnection, config);

export const createWithConnection = (
  conn: StardogConnection,
  idx: number | undefined,
  opts: MarketplaceOptions,
  config: ConnectionConfig
): ConnectionFactory =>
  new DefaultConnectionFactory(idx, opts, () => conn, config);

class DefaultConnectionFactory implements ConnectionFactory {
  public connection: StardogConnection;

  public connectionIndex: number | undefined;

  public options: MarketplaceOptions;

  constructor(
    index: number | undefined,
    options: MarketplaceOptions,
    connProvider: (
      conn: BaseConnection,
      config: ConnectionConfig
    ) => StardogConnection,
    config: ConnectionConfig
  ) {
    this.connection = connProvider(options, config);
    this.connectionIndex = index;
    this.options = options;
  }
}
